var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5556_21375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.39062 8.96924H14.6086V15.0336H5.39062V8.96924Z",
    fill: "#BDBEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39062 8.96924H14.6086V11.6376H5.39062V8.96924Z",
    fill: "#87898C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39062 8.96924H14.6086V15.0336H5.39062V8.96924Z",
    stroke: "#45413C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47363 6.30103H17.564L9.99963 2.41943L2.47363 6.30103Z",
    fill: "#BDBEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99963 3.87503L14.7272 6.30103H17.564L9.99963 2.41943L2.47363 6.30103H5.29603L9.99963 3.87503Z",
    fill: "#87898C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47363 6.30103H17.564L9.99963 2.41943L2.47363 6.30103Z",
    stroke: "#45413C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3835 19.3998H1.61629C1.54448 19.3999 1.47356 19.384 1.40864 19.3533C1.34372 19.3226 1.28643 19.2779 1.24089 19.2223C1.19536 19.1668 1.16271 19.1019 1.14531 19.0322C1.12792 18.9625 1.1262 18.8899 1.14029 18.8194L1.43149 17.3642C1.45349 17.2542 1.51294 17.1552 1.59972 17.084C1.6865 17.0128 1.79526 16.9739 1.90749 16.9738H18.0923C18.2045 16.9739 18.3133 17.0128 18.4001 17.084C18.4868 17.1552 18.5463 17.2542 18.5683 17.3642L18.8595 18.8194C18.8736 18.8899 18.8719 18.9625 18.8545 19.0322C18.8371 19.1019 18.8044 19.1668 18.7589 19.2223C18.7134 19.2779 18.6561 19.3226 18.5911 19.3533C18.5262 19.384 18.4553 19.3999 18.3835 19.3998ZM17.7623 16.9738H2.23749L2.64309 15.3998C2.67208 15.2935 2.7355 15.1997 2.82343 15.1332C2.91136 15.0667 3.01885 15.0312 3.12909 15.0322H16.8707C16.9809 15.0312 17.0884 15.0667 17.1763 15.1332C17.2643 15.1997 17.3277 15.2935 17.3567 15.3998L17.7623 16.9738Z",
    fill: "#F0F0F0",
    stroke: "#45413C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4502 8.96924H5.391V15.0336H3.4502V8.96924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4502 8.96924H5.391V9.93964H3.4502V8.96924Z",
    fill: "#BDBEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4502 8.96924H5.391V15.0336H3.4502V8.96924Z",
    stroke: "#45413C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6094 8.96924H16.5502V15.0336H14.6094V8.96924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6094 8.96924H16.5502V9.93964H14.6094V8.96924Z",
    fill: "#BDBEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6094 8.96924H16.5502V15.0336H14.6094V8.96924Z",
    stroke: "#45413C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08887 8.96924H9.02967V15.0336H7.08887V8.96924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08887 8.96924H9.02967V9.93964H7.08887V8.96924Z",
    fill: "#BDBEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08887 8.96924H9.02967V15.0336H7.08887V8.96924Z",
    stroke: "#45413C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9707 8.96924H12.9115V15.0336H10.9707V8.96924Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9707 8.96924H12.9115V9.93964H10.9707V8.96924Z",
    fill: "#BDBEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9707 8.96924H12.9115V15.0336H10.9707V8.96924Z",
    stroke: "#45413C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96489 8.00009H17.0345V8.48409C17.0345 8.61277 16.9834 8.73618 16.8924 8.82717C16.8014 8.91817 16.678 8.96929 16.5493 8.96929H3.45009C3.3214 8.96929 3.19799 8.91817 3.107 8.82717C3.01601 8.73618 2.96489 8.61277 2.96489 8.48409V8.00009ZM2.47969 6.30089H17.5197V7.51369C17.5198 7.57751 17.5074 7.64073 17.4831 7.69973C17.4588 7.75874 17.4231 7.81237 17.378 7.85755C17.3329 7.90273 17.2794 7.93858 17.2204 7.96304C17.1615 7.9875 17.0983 8.00009 17.0345 8.00009H2.96489C2.90107 8.00009 2.83788 7.9875 2.77893 7.96304C2.71999 7.93858 2.66644 7.90273 2.62137 7.85755C2.5763 7.81237 2.54059 7.75874 2.51628 7.69973C2.49196 7.64073 2.47953 7.57751 2.47969 7.51369V6.30089ZM1.83969 5.29529L2.47289 6.30089L9.80169 2.61289C9.8689 2.57936 9.94298 2.56191 10.0181 2.56191C10.0932 2.56191 10.1673 2.57936 10.2345 2.61289L17.5633 6.30089L18.1965 5.29529C18.2335 5.23842 18.2582 5.17442 18.2689 5.10742C18.2797 5.04043 18.2762 4.97192 18.2589 4.90633C18.2415 4.84074 18.2105 4.77953 18.168 4.72664C18.1255 4.67375 18.0724 4.63037 18.0121 4.59929L10.4633 0.708087C10.3259 0.637126 10.1735 0.600098 10.0189 0.600098C9.86426 0.600098 9.71187 0.637126 9.57449 0.708087L2.02489 4.60009C1.96462 4.6311 1.91152 4.6744 1.86901 4.7272C1.8265 4.77999 1.79552 4.84111 1.77807 4.9066C1.76062 4.9721 1.75709 5.04053 1.7677 5.10747C1.77832 5.17442 1.80284 5.2384 1.83969 5.29529Z",
    fill: "#F0F0F0",
    stroke: "#45413C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5556_21375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalIcon);
export default __webpack_public_path__ + "static/media/legal-icon.fce54904cc34af0f33f80c75c3212042.svg";
export { ForwardRef as ReactComponent };